import React from 'react';
import { RefreshCw, Plus } from 'lucide-react';
import styles from './AppointmentHeader.module.css';

export default function AppointmentHeader({ isFetching, onRefresh, onNewAppointment, canCreate }) {
    return (
        <header className={styles.pageHeader}>
            <div className={styles.headerLeft}>
                <span className={styles.breadcrumb}>APPOINTMENTS <span className={styles.slash}>/</span> CALENDAR</span>
                <h1>Appointments</h1>
            </div>
            <div className={styles.headerActions}>
                <button className={styles.secondaryBtn} onClick={onRefresh} disabled={isFetching}>
                    <RefreshCw size={13} className={isFetching ? styles.spin : ''}/> Refresh
                </button>
                {/* 🛡️ PBAC: Only show if user has 'create' permission */}
                {canCreate && (
                    <button className={styles.primaryBtn} onClick={onNewAppointment}>
                        <Plus size={14} /> New Appointment
                    </button>
                )}
            </div>
        </header>
    );
}